import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import ViewSale from "./ViewSale";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { posApi, cancelTokenSource } from "functions/apis";

const useStyles = makeStyles(styles);

export default function MarkSaleAsServed(props) {
  const source = useRef();
  useEffect(() => {
    source.current = cancelTokenSource();
    return () => source.current.cancel("cancelled");
  }, []);

  const { id } = useParams();
  const [redirect, setRedirect] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    posApi
      .post(
        "Sales/MarkAsServed", {
          id: id
        }, {
          cancelToken: source.current.token
        }
      )
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  }

  const classes = useStyles();
  return redirect ? (
    <Redirect to={"/admin/Sale/Paid"} />
  ) : (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>MARK SALE AS SERVED</h4>
            </CardHeader>
            <CardBody>
              <form onSubmit={handleSubmit}>
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  Cancel
                </Button>
                <Button
                  disabled={disabled}
                  color="info"
                  className="like"
                  type="submit"
                  value="Mark as Served"
                >
                Mark as Served
                </Button>
              </form>
              <ViewSale id={id} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
  )
}

MarkSaleAsServed.propTypes = {
  history: PropTypes.object
};
